import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=0aa1fd90&scoped=true&"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js&"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=0aa1fd90&scoped=true&lang=scss&"
import style1 from "./ButtonSecondary.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1fd90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
